import { openBlock as r, createElementBlock as a, normalizeClass as o, renderSlot as n, createElementVNode as s } from "vue";
import { _ as c } from "./main-Df9wF57H.js";
const d = {
  name: "HeadingNode",
  props: {
    modelValue: {
      type: Object,
      required: !0
    }
  },
  computed: {
    node() {
      return this.modelValue;
    },
    customClasses() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.customClasses) || [];
    },
    anchorTag() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.anchorTag) || "";
    }
  }
}, l = ["data-anchor-tag"], i = ["innerHTML"];
function u(e, m, p, _, h, t) {
  return r(), a("div", {
    class: o(["pb-heading", t.customClasses]),
    "data-anchor-tag": t.anchorTag
  }, [
    n(e.$slots, "default", {}, () => [
      s("div", {
        innerHTML: t.node.content.html
      }, null, 8, i)
    ], !0)
  ], 10, l);
}
const T = /* @__PURE__ */ c(d, [["render", u], ["__scopeId", "data-v-a9eb79ce"]]);
export {
  T as default
};
